<ng-template #flyInModalRef let-flyInModal>
  <div class="fly-in-modal">
    <div class="modal-header">
      <h3>{{ header }}</h3>
      <button
        cpGTagEvent
        [params]="{ event_label: 'flyin_modal_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="flyInModal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </div>
</ng-template>
